module.exports = "<div class=\"item-portrait\">\n  <a ui-sref=\"model({modelId: model.id, pageNum: 1})\" ng-if=\"$root.isMember\"><img ng-src=\"{{$root.BASE_CONTENT + model.image}}\" alt=\"{{model.name}}\"></a>\n  <img ng-if=\"!$root.isMember\" ng-src=\"{{$root.BASE_CONTENT + model.image}}\" alt=\"{{model.name}}\">\n</div>\n<div class=\"item-info clear\">\n  <h4>\n    <a ui-sref=\"model({modelId: model.id, pageNum: 1})\" ng-if=\"$root.isMember\">{{model.name}}</a>\n    <a ng-if=\"!$root.isMember\">{{model.name}}</a>\n  </h4>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/site_core/src/components/modelBlock/modelBlock.html
// module id = 178
// module chunks = 0